export default function linearGradient(
  color: string,
  colorState: string,
  angle = 310,
): string {
  return `linear-gradient(${angle}deg, ${color}, ${colorState})`;
}
